export const generalStorageConstants = {
    AUTH: 'auth.token',
    ORDER_CREATED: 'ls.order_created',
    LS_DB: 'ls.deal_banner',
};

const savedOrderModulePrefix = 'ls.saved_order_module';
export const savedOrderModuleConstants = {
    MODULE: `${savedOrderModulePrefix}`,
    PHONE: `${savedOrderModulePrefix}.phone`,
    NAME: `${savedOrderModulePrefix}.name`,
    FNAME: `${savedOrderModulePrefix}.fname`,
    LNAME: `${savedOrderModulePrefix}.lname`,
    EMAIL: `${savedOrderModulePrefix}.email`,
    ADDRESS: `${savedOrderModulePrefix}.address`,
    DEAL: `${savedOrderModulePrefix}.deal`,
    SAVED_ORDER: `${savedOrderModulePrefix}.saved_order`,
    LEAD_SOURCE: `${savedOrderModulePrefix}.lead_source`,
};

const savedAddressModulePrefix = 'ls.saved_address_module';
export const savedAddressModuleConstants = {
    MODULE: `${savedAddressModulePrefix}`,
};
